import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from 'applib-frontend';
const TooltipContent = ({ progress, text, url }) => {
    const { intl } = useI18n();
    if (progress === 'fail_not_enough_credit') {
        return (_jsxs("p", { children: [intl.formatMessage({ id: text }), ' ', ' ', _jsx("a", { href: `${url}/account`, target: "_blank", rel: "noreferrer", children: intl.formatMessage({ id: 'here' }) })] }));
    }
    return intl.formatMessage({ id: text });
};
export default TooltipContent;
